import { markRaw } from "vue";
import FieldInput from "../components/fields/FieldInput.vue";
import FieldTextarea from "../components/fields/FieldTextarea.vue";
import FieldSelect from "../components/fields/FieldSelect.vue";

type ComponentResolver = (fieldType: string) => unknown;

export const useFieldRegistry = () => {
  const components: Record<string, unknown> = {
    text: markRaw(FieldInput),
    textarea: markRaw(FieldTextarea),
    select: markRaw(FieldSelect),
    EMAIL: markRaw(FieldInput),
    email: markRaw(FieldInput),
    PHONE: markRaw(FieldInput),
    phone: markRaw(FieldInput),
    number: markRaw(FieldInput),
    NUMBER: markRaw(FieldInput),
    SINGLE_LINE_TEXT: markRaw(FieldInput),
    single_line_text: markRaw(FieldInput),
    MULTI_LINE_TEXT: markRaw(FieldTextarea),
    multi_line_text: markRaw(FieldTextarea),
    dropdown: markRaw(FieldSelect),
    DROPDOWN: markRaw(FieldSelect)
  };

  const resolveComponent: ComponentResolver = (fieldType: string) => {
    const normalized = fieldType.toLowerCase();
    const entry = components[fieldType] ?? components[normalized];
    if (entry !== undefined) {
      return entry;
    }

    return markRaw(FieldInput);
  };

  return { resolveComponent };
};
